import * as z from "zod";

export const getCollections = {
  name: "getCollections" as const,
  input: z.object({
    page: z.number().min(1).default(1).optional(),
    pageSize: z.number().min(1).max(100).default(10).optional(),
    searchQuery: z.string().optional(),
  }),
  output: z.object({
    collections: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        handle: z.string(),
        description: z.string().optional(),
        image: z.string().optional(),
        productCount: z.number().optional(),
      }),
    ),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
  }),
};
